import { c as _c } from "react/compiler-runtime";
import ContactForm from "../contact-form";
export default function MoreIndustriesSection() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute inset-0 bg-primary/60 dark:bg-primary/20" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="relative w-full lg:min-h-screen flex flex-col">{t0}<div className="relative z-10 flex-1 flex flex-col items-center justify-center px-6 py-16 sm:px-12 sm:py-16 lg:p-20"><div className="max-w-4xl mx-auto"><div className="flex items-center justify-center gap-2 mb-4"><div className="h-px flex-1 max-w-16 bg-foreground/20" /><p className="text-xs font-mono text-foreground/50">IND-4RP</p><div className="h-px flex-1 max-w-16 bg-foreground/20" /></div><h2 className="text-4xl md:text-5xl lg:text-6xl font-sans font-bold text-foreground mb-6 text-center">¿Y SU INDUSTRIA?</h2><p className="text-sm font-mono text-foreground/70 leading-relaxed mb-8 max-w-2xl mx-auto text-center">Desde finanzas hasta salud, desde telecomunicaciones hasta agricultura, nuestro software está listo para transformar la operativa con inteligencia libre y soberana.</p><ContactForm /></div></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}